export var AccountSuggestionStatus;
(function (AccountSuggestionStatus) {
    AccountSuggestionStatus["Pending"] = "PENDING";
    AccountSuggestionStatus["Accepted"] = "ACCEPTED";
    /** Hidden until `dismissedUntil`. */
    AccountSuggestionStatus["Dismissed"] = "DISMISSED";
    /** Never suggested again for that bank + digits. */
    AccountSuggestionStatus["Never"] = "NEVER";
})(AccountSuggestionStatus || (AccountSuggestionStatus = {}));
//# sourceMappingURL=account-suggestion-status.enum.js.map